import * as z from "zod/v4";

export const cancelOrder = {
  name: "cancelOrder" as const,
  input: z.object({
    shopifyOrderId: z.string(),
    refund: z.boolean(),
    currency: z.string(),
    restockLocationId: z.number().optional(),
    reason: z
      .enum(["customer", "inventory", "fraud", "declined", "other"])
      .optional(),
    email: z.boolean(),
  }),
  output: z.object({ success: z.boolean() }),
};
